<template>
  <div class="cases">
    <!-- 页面标题 -->
    <section class="page-title">
      <div class="container">
        <h1>成功案例</h1>
        <p>展示我们的物联网解决方案在实际应用中的成功案例</p>
      </div>
    </section>

    <!-- 案例列表 -->
    <section class="cases-section">
      <div class="container">
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="8" v-for="(case_item, index) in cases" :key="index">
            <div class="case-card" @click="showCaseDetail(case_item)">
              <div class="case-image">
                <img :src="case_item.image" :alt="case_item.title">
                <div class="case-category">{{ case_item.category }}</div>
              </div>
              <div class="case-content">
                <h3>{{ case_item.title }}</h3>
                <p>{{ case_item.description }}</p>
                <div class="case-info">
                  <span><i class="el-icon-location"></i> {{ case_item.location }}</span>
                  <span><i class="el-icon-date"></i> {{ case_item.date }}</span>
                </div>
                <el-button type="text" class="learn-more">
                  查看详情 <i class="el-icon-arrow-right"></i>
                </el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 案例详情对话框 -->
    <el-dialog
      :title="selectedCase ? selectedCase.title : ''"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose">
      <div class="case-detail" v-if="selectedCase">
        <div class="detail-image">
          <img :src="selectedCase.image" :alt="selectedCase.title">
          <div class="case-category">{{ selectedCase.category }}</div>
        </div>
        <div class="detail-content">
          <div class="case-info">
            <span><i class="el-icon-location"></i> {{ selectedCase.location }}</span>
            <span><i class="el-icon-date"></i> {{ selectedCase.date }}</span>
          </div>
          <h2>{{ selectedCase.title }}</h2>
          <p class="description">{{ selectedCase.description }}</p>
          <div class="challenges">
            <h3>项目挑战</h3>
            <ul>
              <li v-for="(challenge, index) in selectedCase.challenges" :key="index">
                {{ challenge }}
              </li>
            </ul>
          </div>
          <div class="solutions">
            <h3>解决方案</h3>
            <ul>
              <li v-for="(solution, index) in selectedCase.solutions" :key="index">
                {{ solution }}
              </li>
            </ul>
          </div>
          <div class="results">
            <h3>项目成果</h3>
            <ul>
              <li v-for="(result, index) in selectedCase.results" :key="index">
                {{ result }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Cases',
  data() {
    return {
      dialogVisible: false,
      selectedCase: null,
      cases: [
        {
          id: 1,
          title: '某大型制造企业设备监控系统',
          category: '工业物联网',
          location: '江苏省苏州市',
          date: '2023年',
          description: '为大型制造企业提供设备监控解决方案，实现设备运行状态实时监控和预测性维护',
          image: require('@/assets/images/case1.jpg'),
          challenges: [
            '设备种类繁多，协议不统一',
            '数据采集实时性要求高',
            '系统需要高可用性'
          ],
          solutions: [
            '采用多协议网关设备，统一数据采集',
            '使用边缘计算技术，提高数据处理效率',
            '采用分布式架构，确保系统高可用'
          ],
          results: [
            '设备故障率降低40%',
            '维护成本降低30%',
            '生产效率提升25%'
          ]
        },
        {
          id: 2,
          title: '智慧城市环境监测系统',
          category: '智慧城市',
          location: '浙江省杭州市',
          date: '2023年',
          description: '部署城市环境监测系统，实现空气质量、噪声等环境指标的实时监测',
          image: require('@/assets/images/case2.jpg'),
          challenges: [
            '监测点分布广，维护困难',
            '数据传输量大，网络要求高',
            '需要长期稳定运行'
          ],
          solutions: [
            '采用低功耗设计，延长设备寿命',
            '使用NB-IoT网络，降低传输成本',
            '建立完善的运维体系'
          ],
          results: [
            '环境数据实时监测覆盖率100%',
            '系统运行稳定性99.9%',
            '运维成本降低50%'
          ]
        },
        {
          id: 3,
          title: '智能农业温室控制系统',
          category: '智慧农业',
          location: '山东省寿光市',
          date: '2023年',
          description: '为大型农业园区提供温室环境控制系统，实现作物生长环境的智能化管理',
          image: require('@/assets/images/case3.jpg'),
          challenges: [
            '环境参数复杂，控制难度大',
            '需要适应不同作物生长需求',
            '系统操作要简单易用'
          ],
          solutions: [
            '采用智能算法，实现环境参数自动调节',
            '建立作物生长模型，优化控制策略',
            '开发移动端APP，方便远程管理'
          ],
          results: [
            '作物产量提升35%',
            '能源消耗降低40%',
            '人工成本降低60%'
          ]
        }
      ]
    }
  },
  methods: {
    showCaseDetail(case_item) {
      this.selectedCase = case_item
      this.dialogVisible = true
    },
    handleClose(done) {
      this.selectedCase = null
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
.cases {
  .page-title {
    background: linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('~@/assets/images/cases-bg.jpg');
    background-size: cover;
    background-position: center;
    color: #fff;
    padding: 100px 0;
    text-align: center;
    
    h1 {
      font-size: 48px;
      margin-bottom: 20px;
    }
    
    p {
      font-size: 20px;
      opacity: 0.9;
    }
  }
  
  .cases-section {
    padding: 80px 0;
    
    .case-card {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      margin-bottom: 30px;
      cursor: pointer;
      transition: transform 0.3s;
      
      &:hover {
        transform: translateY(-5px);
        
        .case-image img {
          transform: scale(1.1);
        }
        
        .learn-more i {
          transform: translateX(5px);
        }
      }
      
      .case-image {
        position: relative;
        height: 200px;
        overflow: hidden;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s;
        }
        
        .case-category {
          position: absolute;
          top: 20px;
          right: 20px;
          background: rgba(0,0,0,0.6);
          color: #fff;
          padding: 4px 12px;
          border-radius: 4px;
          font-size: 14px;
        }
      }
      
      .case-content {
        padding: 20px;
        
        h3 {
          font-size: 20px;
          margin-bottom: 10px;
          color: #2c3e50;
        }
        
        p {
          color: #666;
          margin-bottom: 15px;
          line-height: 1.6;
        }
        
        .case-info {
          display: flex;
          gap: 20px;
          margin-bottom: 15px;
          color: #666;
          font-size: 14px;
          
          span {
            display: flex;
            align-items: center;
            
            i {
              margin-right: 5px;
            }
          }
        }
        
        .learn-more {
          padding: 0;
          font-size: 16px;
          
          i {
            margin-left: 5px;
            transition: transform 0.3s;
          }
        }
      }
    }
  }
}

.case-detail {
  .detail-image {
    position: relative;
    margin-bottom: 30px;
    
    img {
      width: 100%;
      max-height: 400px;
      object-fit: cover;
      border-radius: 8px;
    }
    
    .case-category {
      position: absolute;
      top: 20px;
      right: 20px;
      background: rgba(0,0,0,0.6);
      color: #fff;
      padding: 4px 12px;
      border-radius: 4px;
      font-size: 14px;
    }
  }
  
  .detail-content {
    .case-info {
      display: flex;
      gap: 20px;
      margin-bottom: 20px;
      color: #666;
      font-size: 14px;
      
      span {
        display: flex;
        align-items: center;
        
        i {
          margin-right: 5px;
        }
      }
    }
    
    h2 {
      font-size: 24px;
      margin-bottom: 20px;
      color: #2c3e50;
    }
    
    .description {
      color: #666;
      margin-bottom: 30px;
      line-height: 1.6;
    }
    
    h3 {
      font-size: 18px;
      margin-bottom: 15px;
      color: #2c3e50;
    }
    
    .challenges, .solutions, .results {
      margin-bottom: 30px;
      
      ul {
        list-style: none;
        padding: 0;
        
        li {
          position: relative;
          padding-left: 20px;
          margin-bottom: 10px;
          color: #666;
          line-height: 1.6;
          
          &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 8px;
            width: 6px;
            height: 6px;
            background: #409EFF;
            border-radius: 50%;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .cases {
    .page-title {
      padding: 60px 0;
      
      h1 {
        font-size: 32px;
      }
      
      p {
        font-size: 16px;
      }
    }
    
    .cases-section {
      padding: 40px 0;
    }
  }
  
  .case-detail {
    .detail-image {
      img {
        max-height: 300px;
      }
    }
  }
}
</style> 